export const fontSizes: { [key: string]: string } = {
  h1: '3.5rem',
  h1_break: '2.5rem',
  h2: '2.8rem',
  h2_break: '2.15rem',
  h3: '2rem',
  h3_break: '1.825rem'
}

export const fontWeights: { [key: string]: number | 'normal' | 'bold' } = {
  weight_600: 600,
  weight_500: 500,
  weight_400: 400,
  weight_300: 300,
  weight_200: 200,
  bold: 'bold',
  normal: 'normal'
}

export const lineHeights: { [key: string]: string } = {
  edito: '1.4'
}
